/* const workbench = {
  editor: [
    'title',
    'heading',
    'fontSize',
    'bold',
    'italic',
    'underline',
    'deleteLine',
    'script',
    'colorStyle',
    'outlineList',
    'indent',
    'align',
    'find',
    'data',
    'picture',
    'document',
    'link',
    'blockquote',
    'horizonRule',
    'code',
    'inlineCode',
    'processOn',
    'emoji',
    'table',
    'et',
    'third',
    'comment',
    'paragraphHandler',
    'history',
    'catalog',
    'storgae',
    'markdown',
    'at',
    'kdocsTodo',
    'template',
    'schedule',
    'group_card',
    'shareBlock',
    'latex',
    'db',
    'date',
    'user',
    'groupCard',
    'highlightBlock',
    'record',
    'countdown',
    'lockBlock',
    'fragmentTemplate',
    'wordCount',
    'intentionCollection',
    'imageColumn',
    'video'
  ],
  view: [
    'startTab',
    'fullComment',
    'messageBubble',
    'mobileReadMenu',
    'mobileMenu',
    'contextMenu'
  ],
  other: []
} */
export const otlOptions = {
  // loadOptions: JSON.stringify({ workbench }),
  // 关闭全文评论
  enableFullComment: false,
  // 不显示文档信息（标题下方）
  disableUserInfo: true
  // scence: 'embedDeliframe',
}

export function getOtlOptions({ isReadonly = false }): Record<string, unknown> {
  return {
    // 关闭全文评论
    // enableFullComment: false,
    // 不显示文档信息（标题下方）
    disableUserInfo: !!isReadonly
  }
}
export const commandBars = [
  /* {
    cmbId: 'HeaderMiddle', // 组件 ID
    attributes: {
      visible: false, // 隐藏组件
      enable: false // 禁用组件，组件显示但不响应点击事件
    }
  } */
  {
    // 金小獴
    cmbId: 'FloatQuickHelp',
    attributes: {
      visible: false
    }
  }
]
/* const forBibComids = [
  // 公共
  'TabPrintPreview',
  'FloatQuickHelp',
  'HistoryRecord',
  'HistoryVersion',
  'MenuPrintPreview',
  'HeaderHistoryMenuBtn',
  'MoreMenus',
  'DownloadImg',
  'ShareLink',
  //   文字
  /!* 'StartTab',
  'InsertTab',
  'TabReviewWord', *!/
  'ReviewTrackChanges'
]
forBibComids.forEach(it => {
  commandBars.push({
    cmbId: it,
    attributes: {
      visible: false,
      enable: false
    }
  })
}) */
export const commonOptions = {
  isShowTopArea: true,
  isShowHeader: true,
  isEnableChangeDocumentTitle: false // 禁用修改页面标题
}
